import { createSlice } from '@reduxjs/toolkit';
import { Notification } from 'components/CustomNotification';
import {
  AddCommentReaction,
  GetCommentReactionById,
  RemoveCommentReactionById,
  AddReplyReaction,
  GetReplyReactionById,
  RemoveReplyReactionById,
} from '../services/ReactionService';

export const ReactionSlice = createSlice({
  name: 'dropdown',
  initialState: {
    addCommentReaction: '',
    addReplyReaction: '',
    getReplyReaction: '',
    getCommentReaction: '',
  },
  reducers: {
    addCommentReaction: (state, action) => {
      state.addCommentReaction = [action.payload];
    },
    getCommentReaction: (state, action) => {
      state.getCommentReaction = [action.payload];
    },
    addReplyReaction: (state, action) => {
      state.addReplyReaction = [action.payload];
    },
    getReplyReaction: (state, action) => {
      state.getReplyReaction = [action.payload];
    },
  },
});

export const AddCommentReactionList = (payload) => async (dispatch) => {
  AddCommentReaction(payload)
    .then((response) => {
      dispatch(addCommentReaction(response));
    })
    .catch((err) => {
      Notification('warning', err.response?.data?.message);
    });
};

export const getCommentReactionBypostId = (data) => async (dispatch) => {
  GetCommentReactionById(data)
    .then((response) => {
      dispatch(getCommentReaction(response));
    })
    .catch((err) => {
      dispatch(getCommentReaction(err.response));
    });
};
export const removeCommentReactionBypostId = (data) => async (dispatch) => {
  RemoveCommentReactionById(data)
    .then((response) => {
      dispatch(getCommentReactionBypostId(data));
    })
    .catch((err) => {
      Notification('warning', err.response?.data?.message);
    });
};

export const AddReplyReactionList = (payload) => async (dispatch) => {
  AddReplyReaction(payload)
    .then((response) => {
      dispatch(addReplyReaction(response));
    })
    .catch((err) => {
      Notification('warning', err.response?.data?.message);
    });
};

export const getReplyReactionBypostId = (data) => async (dispatch) => {
  GetReplyReactionById(data)
    .then((response) => {
      dispatch(getReplyReaction(response));
    })
    .catch((err) => {
      dispatch(getReplyReaction(err.response));
    });
};
export const removeReplyReactionBypostId = (data) => async (dispatch) => {
  RemoveReplyReactionById(data)
    .then((response) => {
      dispatch(getReplyReactionBypostId(data));
    })
    .catch((err) => {
      Notification('warning', err.response?.data?.message);
    });
};

export const {
  ReactionList,
  getCommentReaction,
  addCommentReaction,
  addCommentReactionReply,
  getReplyReaction,
  addReplyReaction,
  addReplyReactionReply,
} = ReactionSlice.actions;
export default ReactionSlice.reducer;
